const Logo: React.FC<React.ComponentPropsWithoutRef<"svg">> = (props) => (
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 587 177"
    height="40"
    {...props}
  >
    <g id="Layer">
      <path
        id="Layer"
        fill="var(--color-primary)"
        fillRule="evenodd"
        d="m127 94.7c1.9 14.3 9.7 22.9 21.4 22.9 9.1 0 16.5-3.3 21.7-9.6l9.7 11.4c-8.4 9.8-19.6 15.6-31.9 15.6-22.4 0-38.4-21.1-38.4-47.4 0-26.3 15.9-47 38-47 22.1 0 38 20 38 47.2v6.9zm41.2-13.8c0-13.4-8.8-23.2-20.8-23.2-11.4 0-18.9 8.7-20.5 23.2z"
      />
      <path
        id="Layer"
        fill="var(--color-primary)"
        d="m258.4 50.6l-5.9 14.3c-7.1-5.3-16.5-8.5-24.1-8.5-7.8 0-11.8 3.3-11.8 10 0 5.3 2.5 7.3 12.4 10.7l8.1 2.7c17 5.8 23.4 13.1 23.4 26.5 0 18.2-11.1 28.7-30.2 28.7-12.3 0-24.4-4.4-33.6-12.2l6.1-14c8.4 6.5 18.6 10.4 28.1 10.4 8.8 0 13.1-3.6 13.1-11.3 0-5.4-2.2-7.4-11.3-10.7l-9.1-3.1c-17.6-6.2-23.8-12.7-23.8-25.8 0-17.4 11-27.8 29-27.8 10.6 0.1 21.6 3.8 29.6 10.1z"
      />
      <path
        id="Layer"
        fill="var(--color-primary)"
        d="m320 142.1c-6.2 19.4-15.3 28.3-28.6 28.3-5.8 0-12.1-1.6-19.2-4.9l5.1-15.3c4.3 2.2 8.4 3.3 11.8 3.3 6.8 0 11.1-4.2 15.4-14.5l1.2-2.9-32-93.7h18.5l21.4 67 20.2-67h18.2z"
      />
      <path
        id="Layer"
        fill="var(--color-primary)"
        d="m429.5 55.3c10.2-10.9 19.6-14.7 30.5-14.7 14.6 0 25.7 10.7 25.7 32.3v60.3h-17.7v-53.9c0-13.6-5.9-20.7-14.9-20.7-8.1 0-15.3 3.4-21.5 9.8 0.7 4.2 1 7.8 1 12.7v52.1h-17.5v-53.9c0-13.6-6.1-20.7-15-20.7-7.4 0-13.4 2.7-20.4 9.8v64.8h-17.6v-90.8h17.6v12.3c8.9-9.8 18.2-14.2 28-14.2 9.7 0.1 17.6 5 21.8 14.8z"
      />
      <path
        id="Layer"
        fill="var(--color-primary)"
        fillRule="evenodd"
        d="m577.4 87.8c0 26.9-17.3 47.2-40.3 47.2-22.7 0-40-20.3-40-47.2 0-26.9 17.3-47.2 40-47.2 22.9 0 40.3 20.4 40.3 47.2zm-63 0c0 16.2 9.7 28.3 22.7 28.3 13.1 0 23-12.2 23-28.3 0-16.1-9.8-28.3-23-28.3-13 0-22.7 12.2-22.7 28.3z"
      />
      <path
        id="Layer"
        fill="var(--color-primary)"
        d="m64.9 27.4v-19.3l-26.2 12.5v19.3z"
      />
      <path
        id="Layer"
        fill="var(--color-primary)"
        d="m97.8 40.6l-88.9-0.8v17.3h27.6v38.7c0 21.5 17.4 38.9 38.9 38.9h23l0.1-17-25.6-0.1c-10.5-0.1-19-8.5-19-19l-0.1-40.6 44.2 0.8v-18.2z"
      />
    </g>
  </svg>
)

export default Logo
